import o from "./isBoolean.js";
import r from "./_cb.js";
import s from "./_getLength.js";
import t from "./contains.js";
function n(n, p, u, i) {
  o(p) || (i = u, u = p, p = !1), null != u && (u = r(u, i));
  for (var m = [], f = [], a = 0, e = s(n); a < e; a++) {
    var h = n[a],
      j = u ? u(h, a, n) : h;
    p && !u ? (a && f === j || m.push(h), f = j) : u ? t(f, j) || (f.push(j), m.push(h)) : t(m, h) || m.push(h);
  }
  return m;
}
export { n as default };